// import React from 'react';
// import { Popover, OverlayTrigger } from 'react-bootstrap';

// interface PopoverCustomProps {
//   childern: React.ReactNode; // محتوى العنصر الذي سيقوم بتفعيل الـ Popover
//   Header?: string; // عنوان الـ Popover (اختياري)
//   Body: React.ReactNode; // محتوى الـ Popover
//   placement?: 'top' | 'right' | 'bottom' | 'left'; // تحديد موضع الـ Popover (افتراضيًا أعلى)
// }

// const PopoverCustom: React.FC<PopoverCustomProps> = ({
//   childern: triggerContent,
//   Header: popoverTitle,
//   Body: popoverContent,
//   placement = 'top',
// }) => {
//   return (
//     <OverlayTrigger
//       // flip={false} 
//       container={document.body} // استخدام الـ body كحاوية للتراكب
//       // offset={[0, 10]} // تعديل الموضع قليلاً
//        // container={document.body}
//       // rootClose={false}
//       // offset={[0, 10]}
//       // show={true}
//       popperConfig={{
//         modifiers : [
//           {
//             name:'preventOverflow',
//             options :{
//               boundary: 'viewport', // يمنع تجاوز حدود الشاشة

//             }
//           }
//         ]
//       }}
//       placement={placement}
 
//        overlay={
//         <Popover className="text-center border border-theme shadow m-0">
//           {popoverTitle && (
//             <Popover.Header className="text-center fw-bold small bg-theme bg-opacity-25 m-0">
//               <h6 className="m-0">{popoverTitle}</h6>
//             </Popover.Header>
//           )}
//           <Popover.Body className="m-0">{popoverContent}</Popover.Body>
//         </Popover>
//       }
//       trigger={['hover', 'focus', 'click']}
      
//       >
//       <span>{triggerContent}</span>
//     </OverlayTrigger>
//   );
// };

// export default PopoverCustom;

import React, { useEffect, useRef } from 'react';
import { Popover, OverlayTrigger, type OverlayTriggerProps } from 'react-bootstrap';

interface PopoverCustomProps {
  childern?: React.ReactNode;          // نفس الاسم الموجود عندك
  children?: React.ReactNode;          // دعم الاسم القياسي
  Header?: string;
  Body: React.ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  trigger?: OverlayTriggerProps['trigger']; // تحكم بالمحفزات (اختياري)
}

const PopoverCustom: React.FC<PopoverCustomProps> = ({
  childern,
  children,
  Header: popoverTitle,
  Body: popoverContent,
  placement = 'top',
  trigger = ['hover', 'focus'], // ✅ لا نستخدم click افتراضيًا حتى لا يتعارض مع onClick للعنصر
}) => {
  const overlayRootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    let el = document.getElementById('ntx-overlay-root') as HTMLElement | null;
    if (!el) {
      el = document.createElement('div');
      el.id = 'ntx-overlay-root';
      Object.assign(el.style, {
        position: 'fixed',
        inset: '0',
        overflow: 'hidden',
        zIndex: '3000',
        pointerEvents: 'none', // ✅ لا يمنع التفاعل مع الصفحة
      });
      document.body.appendChild(el);
    }
    overlayRootRef.current = el;
  }, []);

  const triggerContent = children ?? childern;
  const childEl = React.isValidElement(triggerContent) ? (
    triggerContent
  ) : (
    <span>{triggerContent}</span>
  );

  return (
    <OverlayTrigger
      placement={placement}
      trigger={trigger}
      // ✅ مهم: نرسم التراكب داخل Root ثابت يمنع ظهور scrollbars لحظيًا
      container={() => overlayRootRef.current || document.body}
      popperConfig={{
        strategy: 'fixed',
        modifiers: [
          { name: 'computeStyles', options: { adaptive: false } },
          { name: 'offset', options: { offset: [0, 8] } },
          {
            name: 'preventOverflow',
            options: {
              boundary: 'viewport',
              rootBoundary: 'viewport',
              padding: 8,
              altBoundary: true,
              tether: false,
            },
          },
          { name: 'flip', options: { fallbackPlacements: ['right', 'left', 'top', 'bottom'] } },
        ],
      }}
      overlay={
        <Popover
          className="text-center border border-theme shadow m-0"
          style={{ pointerEvents: 'auto' }} // popover نفسه عادي
        >
          {popoverTitle && (
            <Popover.Header className="text-center fw-bold small bg-theme bg-opacity-25 m-0">
              <h6 className="m-0">{popoverTitle}</h6>
            </Popover.Header>
          )}
          <Popover.Body className="m-0">{popoverContent}</Popover.Body>
        </Popover>
      }
    >
      {childEl}
    </OverlayTrigger>
  );
};

export default PopoverCustom;

